import "./App.css";
import ComponentTest from "./moduls/uiTestingModul";
import AuthValidasi from "./moduls/Auth/views/AuthValidasi";
import GenerateAuth from "./moduls/Auth/views/GenerateAuth";
import { Outlet } from "react-router-dom/dist";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import SessionMethodVideoModul from "./moduls/SessionMethodVideoModul";
import RecordingModul from "./moduls/RecordingModul";
import WaitingRoomModul from "./moduls/WaitingRoomModul";
import Page404 from "./general/pages/Page404";
import Page415 from "./general/pages/Page415";
import { AppBuildMode } from "./general/init/envConfig";
import PduliModul from "./moduls/PduliModul";
import RoomTesting from "./moduls/TestingVideo";
import PartValidationCode from "./moduls/PduliModul/views/parts/PartValidationCode";
import AuthValidasiPduli from "./moduls/PduliModul/views/parts/AuthValidasiPduli";

function App() {
  if (!AppBuildMode(process.env.REACT_APP_BUILD_MODE).DEV) {
    console.log = console.warn = console.error = () => {};
  }
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* KonselorMode */}
          <Route path="/pduli" element={<PartValidationCode />} />
          <Route
            path="/pduli-session"
            element={
              <>
                <AuthValidasiPduli />
              </>
            }
          >
            <Route path="/pduli-session" element={<PduliModul />} />
            {/* <Route path="/pduli/testing" element={<>Testing</>} /> */}
          </Route>

          {/* generateMeeting */}
          <Route path="/session" element={<GenerateAuth />} />
          <Route path="/" element={<AuthValidasi />}>
            <Route
              path="/Live/:uiMode/:sessionName"
              element={<SessionMethodVideoModul />}
            />
            <Route
              path="/waiting-room/:sessionName"
              element={<WaitingRoomModul />}
            />
          </Route>
          <Route path="/recording/session" element={<RecordingModul />} />
          {/* Route with validasi */}
          <Route path="/404" element={<Page404 />} />
          <Route path="/415" element={<Page415 />} />
          <Route path="/testcomponent" element={<ComponentTest />} />
          {/* Testing Agora */}
          {/* <Route
            path="/roomTesting/:session/:selfUid"
            element={<RoomTesting />}
          /> */}
          {/* End Testing Agora */}
          <Route path="/*" element={<Navigate to="/404" />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
